import { Tab } from '@mui/material';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader, QueryTabPanel, QueryTabs } from 'components';
import {
  PayoutRequisitesAutomationList,
  PayoutRequisitesList,
} from 'features/payout-requisites';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';

enum PayoutArchiveTabs {
  Requisites = 'requisites',
  RequisitesAutomation = 'requisites-automation',
}

export const PayoutArchivePage = () => {
  // TODO: move tkeys
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.archive',
  });
  const { isAdminOrTechOperator, isTrader } = useUser();

  return (
    <Fragment>
      <PageHeader title={t('title')} divider={false} />
      <QueryTabs tabsEnum={PayoutArchiveTabs}>
        <Tab
          value={PayoutArchiveTabs.Requisites}
          label={t('tabs.requisites')}
        />
        {(isAdminOrTechOperator || isTrader) && (
          <Tab
            value={PayoutArchiveTabs.RequisitesAutomation}
            label={t(`tabs.payout_requisites_automation`)}
          />
        )}
      </QueryTabs>
      <QueryTabPanel value={PayoutArchiveTabs.Requisites}>
        <PayoutRequisitesList archived />
      </QueryTabPanel>
      {(isAdminOrTechOperator || isTrader) && (
        <QueryTabPanel value={PayoutArchiveTabs.RequisitesAutomation}>
          <PayoutRequisitesAutomationList archived />
        </QueryTabPanel>
      )}
    </Fragment>
  );
};
